<template>
	<div class="primary-bg full-width full-height">
		<div id="help-support-left" class="left full-height">
			<HelpSupportMenu class="full-width" />
		</div>
		<div id="help-support-right" class="right full-height overflow-y-scroll">
			<router-view class="margin-center"></router-view>
		</div>
		<div class="clear"></div>
	</div>
</template>

<script>
import HelpSupportMenu from "@/components/pages/help-and-support/HelpSupportMenu";

export default {
	name: "LeftPanel",
	components: {
		HelpSupportMenu
	}
};
</script>

<style>
:root {
	--help-left-width: 300px;
}
#help-support-left {
	width: var(--help-left-width);
	-webkit-box-shadow: 15px 0px 17px -2px rgba(0, 0, 0, 0.7);
	box-shadow: 15px 0px 17px -2px rgba(0, 0, 0, 0.7);
}
#help-support-right {
	width: calc(100% - var(--help-left-width) - 15px);
}
#help-support-right > div {
	width: 100%;
	max-width: 760px;
	opacity: 0.8;
	font-size: 16px;
	line-height: 1.7;
	color: #ffffff;
}
</style>
